var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-top"},[_c('div',{staticClass:"price-top-content"},[_c('p',[_vm._v("使用云渲染比本地渲染更快速、更高效")]),_c('p',{staticClass:"price-title"},[_c('span',{staticClass:"active"},[_vm._v("时间")]),_vm._v("即是生产力")])])])
}]

export { render, staticRenderFns }